import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './SearchForm.css';

function SearchForm({
  patente,
  setPatente,
  jurisdicciones,
  selectedJurisdicciones,
  toggleJurisdiccion,
  onSubmit,
  loading
}) {
  return (
    <form onSubmit={onSubmit} className="search-form">
      <div className="form-group">
        <label htmlFor="patente">Patente del Vehículo</label>
        <input
          type="text"
          id="patente"
          className="patente-input"
          placeholder="Ej: AG646BA"
          value={patente}
          onChange={(e) => setPatente(e.target.value.toUpperCase())}
          maxLength={7}
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Jurisdicciones a Consultar</label>
        <div className="jurisdicciones-selector">
          {jurisdicciones.map((j) => (
            <button
              key={j.codigo}
              type="button"
              className={`jurisdiccion-btn ${
                selectedJurisdicciones.includes(j.codigo) ||
                selectedJurisdicciones.length === 0
                  ? 'selected'
                  : ''
              }`}
              onClick={() => toggleJurisdiccion(j.codigo)}
              disabled={loading}
            >
              {j.nombre} ({j.codigo})
            </button>
          ))}
        </div>
        <small className="help-text">
          {selectedJurisdicciones.length === 0
            ? 'Se consultarán todas las jurisdicciones'
            : `Se consultará ${selectedJurisdicciones.length} jurisdicción(es)`}
        </small>
      </div>

      <button type="submit" className="submit-btn" disabled={loading}>
        {loading ? (
          <><FontAwesomeIcon icon={faSpinner} spin /> Consultando...</>
        ) : (
          <><FontAwesomeIcon icon={faSearch} /> Consultar Multas</>
        )}
      </button>
    </form>
  );
}

export default SearchForm;
